import React from "react";
import { Redirect, useLocation } from "react-router-dom";

import { isUser } from "~/common/user";
import { Loader } from "~/components/ui/loader";
import { useAppSelector } from "~/store";

export const PREV_PATHNAME_STORAGE_KEY = "prev_pathname";

export function Welcome() {
  const userData = useAppSelector((state) => state.user);
  const location = useLocation();

  if (userData.status == "idle" || userData.status == "loading") {
    return <Loader />;
  }

  const to = location.pathname + location.search;

  if (!isUser(userData.data)) {
    window.localStorage.setItem(PREV_PATHNAME_STORAGE_KEY, to);
    return <Redirect to="/login" />;
  }

  return <Redirect to={to} />;
}
